import React from 'react'
import styled from 'react-emotion'
import themeVars from 'ui_theme/site/globals/site.variables'
import { Flex, SVGIcon } from 'shared/ui'
import Switch from 'shared/ui/Switch'
import CloseIcon from 'components/App/DesktopView/shared/Composer/CloseIcon'
import { doOpenMainPage } from 'actions/pages'

const Container = styled(Flex)`
  padding-top: ${themeVars.small};
  padding-left: ${themeVars.big};
  padding-bottom: ${themeVars.small};
  padding-right: ${themeVars.large};
  width: 100%;
  border-bottom: solid 1px ${themeVars.dust};
`
const Title = styled('div')`
  font-size: ${themeVars.large};
  font-weight: ${themeVars.graphikWeightMedium};
  line-height: ${themeVars.large};
  color: ${themeVars.dark};
  width: 100%;
  flex-grow: 1;
`

const Switcher = styled(Flex)`
  flex-grow: 0;
  flex-shrink: 0;
`

const Label = styled('div')`
  font-size: ${themeVars.tiny};
  font-weight: ${themeVars.graphikWeightMedium};
  text-transform: uppercase;
  color: ${props => props.color};
  margin-left: 4px;
  display: flex;
  align-items: center;
`

export default function NewConvoHeader({ isLogging = true, onSwitch }) {
  return (
    <Container alignItems="center">
      <Title>New Conversation</Title>
      <Switcher alignItems="center">
        <Switch
          on={isLogging}
          color={themeVars[isLogging ? 'golden' : 'ultraLight']}
          onClick={onSwitch}
        />
        <Label color={themeVars[isLogging ? 'golden' : 'ultraLight']}>
          <SVGIcon
            name="updatedPhoneLog"
            size={16}
            css={`
              margin-left: 4px;
              margin-right: 2px;
              margin-top: 2px;
              margin-bottom: 2px;
            `}
          />
          Log a conversation
        </Label>
      </Switcher>
      <CloseIcon
        to={doOpenMainPage()}
        css={`
          position: static;
          flex-shrink: 0;
          margin-left: 16px;
        `}
      />
    </Container>
  )
}
